module.exports = __webpack_public_path__ + "static/M3-04-image-d8a57b57f4095e660348b2a3ab2c47ee.png";